import React from 'react'
import { Link } from 'react-router-dom'
import { Table } from 'react-bootstrap'

export const LmsSelection = () => {
  return (
    <div className="container" style={{ width: '100%' }}>
      <div className="mb-2 go-back-button-left-align">
        <a
          className="btn btn-default btn-myed btn-default-myed btn-sm-myed mr-4"
          href="/account/admin_homepage/-/"
        >
          <div className="far fa-arrow-circle-left fa-fw mr-2" /> Go Back
        </a>
      </div>
      <div className="card-myed">
        <h3>LMS Platforms:</h3>
        <Table striped bordered condensed hover>
          <thead>
            <tr>
              <th>Name</th>
              <th>Code</th>
              <th>Go To</th>
            </tr>
          </thead>
          <tbody>
            {[
              { name: 'Blackboard', code: 'blackboard' },
              { name: 'Brightspace', code: 'desire2learn' },
              { name: 'Canvas', code: 'canvas' },
              { name: 'Moodle', code: 'moodle' },
              { name: 'MyEducator Internal', code: 'myed' },
              { name: 'All Platforms (Issuers)', code: 'all' },
            ].map((lms, i) => (
              <tr key={i}>
                <td>{lms.name}</td>
                <td>{lms.code}</td>
                <td>
                  <Link
                    to={`/account/admin_lti13/-/platforms/${lms.code}/issuers`}
                  >
                    View Issuers
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </div>
  )
}
